import { ChevronRight } from "@mui/icons-material";
import { Button, Chip, ChipProps, Grid2, Paper, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { GqlDashboardProjectUserProjectList, GqlProjectStatus } from "~/__generated__";
import { parseStringToDate } from "~/modules/app/util/dateHelpers";
import { formatDate } from "~/modules/app/util/formatters";

type Props = {
    component: GqlDashboardProjectUserProjectList;
};

export default function DashboardProjectUserProjectList({ component }: Props) {
    const { t } = useTranslation("app");

    const projects = component.projects.data;

    return (
        <Grid2 size={12}>
            <Typography variant="h3" paddingBottom={2}>
                {t("dashboardComponents.dashboardProjectUserProjectList.projects")}:
            </Typography>
            <Stack direction="column" rowGap={2}>
                {projects.map(({ project }) => (
                    <Paper variant="outlined" key={project.id} sx={{ padding: 2 }}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                            <Stack direction="column" justifyContent="space-evenly">
                                <Typography variant="overline">{project.client.name}</Typography>
                                <Stack direction="row" columnGap={2} alignItems="center">
                                    <Typography variant="h5">{project.name}</Typography>
                                    <Chip
                                        label={project.status}
                                        color={STATUS_COLOR[project.status]}
                                        size="small"
                                        sx={{ textTransform: "capitalize" }}
                                    />
                                </Stack>
                                {project.startAt && (
                                    <Typography variant="caption">
                                        {t("dashboardComponents.dashboardProjectUserProjectList.startDate")}:{" "}
                                        {formatDate(parseStringToDate(project.startAt))}
                                    </Typography>
                                )}
                            </Stack>
                            <Button
                                endIcon={<ChevronRight />}
                                variant="text"
                                component={Link}
                                to={`/c/${project.client.slug}/p/${project.slug}/`}
                            >
                                {t("dashboardComponents.dashboardProjectUserProjectList.mapViewBtn")}
                            </Button>
                        </Stack>
                    </Paper>
                ))}
            </Stack>
        </Grid2>
    );
}

const STATUS_COLOR: Record<GqlProjectStatus, ChipProps["color"]> = {
    [GqlProjectStatus.Cancelled]: "error",
    [GqlProjectStatus.Open]: "secondary",
    [GqlProjectStatus.Confirmed]: "primary",
    [GqlProjectStatus.Completed]: "success",
};
